import { useContext, useEffect, useState } from "react";
import CancelButton from "../../assets/images/CancelButton.svg";
import SearchIcons from "../../assets/images/SearchIcons.svg";
import OpenSectionButton from "../../assets/images/OpenSectionButton.svg";
import { HelpHubFaqTypes, QuestCriteriaWithStatusType } from "./HelpHub.type";
import QuestContext from "../QuestWrapper";
import { extractGradientColors, useGeneral } from "../../general";


const HelpHubTasks = (props: HelpHubFaqTypes) => {

  const { faqData, contentConfig, styleConfig, setHelpHub, isActive, BrandTheme, QuestThemeData } = props;
  const [faqIndex, setFaqIndex] = useState<number | undefined>(undefined);
  const [filterData, setFilterData] = useState<QuestCriteriaWithStatusType[]>(
    []
  );
  const [searchData, setSearchData] = useState<string | number>("");
  const { themeConfig, user } = useContext(QuestContext.Context);
  const general = useGeneral('quest')

  useEffect(() => {
    let data = faqData.filter((value: QuestCriteriaWithStatusType) => {
      return value?.question
        ?.toLowerCase()
        .includes(searchData?.toString().toLowerCase());
    });
    setFilterData(data);
  }, [faqData, searchData]);

  useEffect(() => {
    if (props?.isOffline) return;
    general.trackEvent(
      "quest-helphub-faq-loaded",
      (props.uniqueUserId || props.userId || user.userId)!,
      {},
      true,
      !props.uniqueUserId,
      true
    );
  }, []);

  const cleanTiptapHTML = (html = "") => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll('[data-node-view-wrapper]').forEach((el) => {
      el.replaceWith(...el.childNodes);
    });

    doc.querySelectorAll('[data-drag-handle]').forEach((el) => el.remove());

    doc.querySelectorAll('[draggable]').forEach((el) =>
      el.removeAttribute('draggable')
    );

    return doc.body.innerHTML;
  };

  return (
    <div
      className={"helpHubHelpCont animatedDissolve"}
      style={{
        background: themeConfig?.backgroundColor,
        ...styleConfig?.Help?.Form,
      }}
    >
      <div className="q-helphub-help-upper-cont ">
        <div className="q-helphub-help-upper-cont-text">
          <div>
            <div
              className="q-helphub-help-upper-cont-text-head"
              style={{
                color: BrandTheme?.titleColor || themeConfig?.primaryColor,
                ...styleConfig?.Help?.Topbar?.Heading,
              }}
            >
              {contentConfig?.heading || "Help Center"}
            </div>
            <div
              className="q-helphub-help-upper-cont-text-para"
              style={{
                color:
                  BrandTheme?.contentColor || themeConfig?.secondaryColor,
                ...styleConfig?.Help?.Topbar?.SubHeading,
              }}
            >
              {contentConfig?.subHeading ||
                "Welcome back, Please talk to us to understand"}
            </div>
          </div>
          <div className="q-helphub-help-upper-cont-text-button">
            <img src={CancelButton} alt="" onClick={() => { setHelpHub(false); isActive && isActive(false) }} />
          </div>
        </div>
      </div>

      <div className="q-helphub-help-lower-cont">
        <div className="q-helphub-help-lower-cont-data">
          {/* search box  */}
          <div
            className="q-helphub-help-search-cont"
            style={{ ...styleConfig?.Help?.Searchbox, borderRadius: QuestThemeData?.borderRadius || BrandTheme?.borderRadius }}
          >
            <input
              className="q-helphub-search-input"
              type="text"
              placeholder="Search for FAQs..."
              onChange={(e) => setSearchData(e.target.value)}
              style={{
                color: BrandTheme?.primaryColor || themeConfig?.primaryColor,
              }}
            />
            <img src={SearchIcons} alt="" />
          </div>

          {/* for faqs  */}
          <div className="q-helphub-help-faqs-cont">
            <div className="q-helphub-help-total-faqs">
              <div
                style={{
                  color: BrandTheme?.primaryColor || (QuestThemeData?.accentColor?.includes("gradient") ? extractGradientColors(QuestThemeData?.accentColor) : QuestThemeData?.accentColor) || BrandTheme?.tertiaryColor || themeConfig?.secondaryColor,
                  fontFamily: BrandTheme?.fontFamily || themeConfig?.fontFamily,
                  WebkitTextFillColor: BrandTheme?.primaryColor || (QuestThemeData?.accentColor?.includes("gradient") ? extractGradientColors(QuestThemeData?.accentColor) : QuestThemeData?.accentColor) || BrandTheme?.tertiaryColor || 'transparent',
                  ...styleConfig?.Help?.Form,
                }}
              >
                {filterData?.length} FAQs
              </div>
            </div>

            <div className="q-helphub-help-total-faqs-cont">
              {filterData?.map(
                (value: QuestCriteriaWithStatusType, index: number) => {
                  return (
                    value.type === "VIEW_ONLY_TEXT" && (
                      <div
                        // className={`q-helphub-help-single-faq-${
                        //   faqIndex === index ? "open" : "close"
                        // }`}
                        className="q-helphub-help-single-faq"
                        key={index}
                      >
                        <div
                          className="text"
                          onClick={() => {
                            index === faqIndex
                              ? setFaqIndex(undefined)
                              : setFaqIndex(index);
                          }}
                        >
                          <div
                            className="head"
                            style={{
                              color:
                                BrandTheme?.titleColor ||
                                themeConfig?.primaryColor,
                              ...styleConfig?.Help?.Card?.Heading,
                            }}
                          >
                            {value?.question}
                          </div>
                          <div className="but">
                            <img src={OpenSectionButton} alt="" />
                          </div>
                        </div>

                        <div
                          className={`${faqIndex === index ? "ansOpen" : "ansClose"
                            }`}
                          style={{
                            color:
                              BrandTheme?.contentColor ||
                              themeConfig?.secondaryColor,
                            ...styleConfig?.Help?.Card?.SubHeading,
                          }}
                          dangerouslySetInnerHTML={{ __html: cleanTiptapHTML(value?.answer) }}
                        />
                      </div>
                    )
                  );
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpHubTasks;
